import { html, View } from 'rune-ts';
import { font, staticFont } from '@services/MarppleShop/shared/typography';

export class ProductListCount extends View<{ count: number; is_mobile?: boolean }> {
  override template() {
    const nbsp = html.preventEscape('&nbsp');
    return html`
      <span
        ><span class="${font('16_medium', '14_medium')}">${ET('mps2::product::total')}</span>${ET.lang != 'jp'
          ? nbsp
          : ''}<span class="${staticFont('unica_16_medium', 'unica_14_medium')}"
          >${this.data.count.toLocaleString()}${ET.lang == 'en' ? nbsp : ''}</span
        ><span class="${font('16_medium', '14_medium')}">${ET('mps2::product::count')}</span></span
      >
    `;
  }

  setCount(count: number) {
    this.data.count = count;
    return this;
  }
}
